module.exports = __webpack_public_path__ + "clippy.c6b234719965cc10df0f.svg";